import React, { Suspense, lazy, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import { useLocation } from "react-router-dom";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import { usePageLeaveGuard } from "../utils/usePageLeaveGuard";

// Lazy loading all tab components
const ElectricityRecording = lazy(() => import("./Electricity/ElectricityRecording"));
const UtilityReport = lazy(() => import("./Electricity/UtilityReport"));
 
const UtilityManagement = () => {
  const location = useLocation();
   const auth = useSelector((state) => state.authentication);
   const {userData} = auth;
  const initialTab = location.state?.activeTab || "1";
  const [activeTab, setActiveTab] = useState(initialTab);
  // Get purchase from location.state if available
// 🛡️ Activate Browser Back/Forward Guard
  const { isDirty, setIsDirty } = usePageLeaveGuard(false);

  return (
    <div className="container mt-4">
      <h2>Manage Utility - (Electricity/Water)</h2>

      {/* Navigation Tabs */}
      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === "1" ? "active" : ""}
            onClick={() => setActiveTab("1")}
          >
            Electricity Recording
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "2" ? "active" : ""}
            onClick={() => setActiveTab("2")}
          >
            Utility Report
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "3" ? "active" : ""}
            onClick={() => setActiveTab("3")}
          >
            Reports
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === "4" ? "active" : ""}
            onClick={() => setActiveTab("4")}
          >
            Settings
          </NavLink>
        </NavItem>
          
      </Nav>

      {/* Tab Content with Lazy Loading */}
   <TabContent activeTab={activeTab} className="mt-3">
  <Suspense fallback={<Loader />}>
    
    <TabPane tabId="1">
      <div style={{ display: activeTab === "1" ? "block" : "none" }}>
        <ElectricityRecording setIsDirty={setIsDirty}/>
      </div>
    </TabPane>
<TabPane tabId="2">
  <div style={{ display: activeTab === "2" ? "block" : "none" }}>
    <UtilityReport userData={userData} activeTab={activeTab} />
  </div>
</TabPane>

  </Suspense>
</TabContent>
    </div>
  );
};

export default UtilityManagement;
